import Service from "../Service";

const job = {

    getAllJobsGroupPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/labour?page=${page}`,{ headers: { Authorization: `Bearer ${data.token}` } });
    },

    getJobsGroup(data) {
        return Service.get(`/api/labour/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createJobsGroup(data) {
        return Service.post(`/api/labour`, {
            name_th: data.name_th,
            name_en: data.name_en
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editJobsGroup(data) {
        return Service.put(`/api/labour/${data.id}`, {
            name_th: data.name_th,
            name_en: data.name_en
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteJobsGroup(data) {
        return Service.delete(`/api/labour/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    }


};

export default job;
